export class ShopUser {
    user_id: number;
    company_id: number;
    email: string;
    user_organisation_name: string;
    user_organisation_vat_number: string;
    user_organisation_type: number;
    user_firstname: string;
    user_infix: string;
    user_lastname: string;
    user_initials: string;
    user_gender: string;
    user_title: string;
    user_zipcode: string;
    user_address: string;
    user_housenumber: string;
    user_city: string;
    country_id: string;
    user_latitude: string;
    user_longitude: string;
    user_delivery_name: string;
    user_delivery_zipcode: string;
    user_delivery_address: string;
    user_delivery_housenumber: string;
    user_delivery_city: string;
    user_delivery_country_id: string;
    user_delivery_latitude: string;
    user_delivery_longitude: string;
    user_telephone: string;
    user_telephone2: string;
    user_fax: string;
    user_email: string;
    user_dob: string;
    user_function: string;
    user_status: number;
    user_default: number;
    user_sort: number;
    user_op_rekening: boolean;
    user_last_logon: string;
    user_number_of_logins: number;
    user_creation_date: string;
    user_last_modified: string;
    user_mailinglist: number;
    user_ext_id: number;
    user_debnr: string;
    user_pricelist: string;
    user_type: string;
    user_discount: string;
    user_language: string;
    user_oprekening: boolean;
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/shop_user.ts